<template lang="pug">
.ui-event-config
  .pre-execution
    .pre-execution-event-group
      .execution-event(v-for="( event, index ) in preExecutionEvents" :key="index")
        .event-name {{ eventLabels[event.name] }}
          aiq-tooltip(placement="top")
            template(v-slot:content)
              div(v-html="$t(`settings_tab.dashboard_tab.ui_event.event.${event.name}.tooltip`)")
            fa-icon.question-mark(:icon="['fas', 'circle-question']")
        .workflow-container
          aiq-select(:placeholder="$t('global.select')"
                     clearable
                     :empty-values="['']"
                     :options="workflows"
                     :value-on-clear="''"
                     v-model="event.payload.name")
            aiq-option(v-for="item in workflows"
                      :key="item"
                      :label="item"
                      :value="item")

  .timezone-button
    aiq-button(@click="onCancel") {{$t('global.cancel')}}
    aiq-button(@click="onSave" :disabled="!isDataChanged" type="primary") {{$t('global.save')}}
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { PRE_EXECUTION_EVENT } from '@/constants/settings';


export default {
  name: 'UiEventConfig',
  computed: {
    isDataChanged() {
      return !isEqual(this.localEventConfig, this.config);
    },
    preExecutionEvents() {
      return get(this.localEventConfig, 'pre_execution.events', []);
    },
    eventLabels() {
      return {
        [PRE_EXECUTION_EVENT.CLOSE_CONVERSATION]: this.$t('settings_tab.dashboard_tab.ui_event.event.close_conversation.label'),
        [PRE_EXECUTION_EVENT.LEAVE_CONVERSATION]: this.$t('settings_tab.dashboard_tab.ui_event.event.leave_conversation.label'),
        [PRE_EXECUTION_EVENT.VIDEO_CALL]: this.$t('settings_tab.dashboard_tab.ui_event.event.video_call.label'),
        [PRE_EXECUTION_EVENT.COBROWSE]: this.$t('settings_tab.dashboard_tab.ui_event.event.cobrowse.label'),
      };
    },

  },
  props: {
    config: {
      type: Object,
      default: null,
    },
    workflows: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['save'],
  watch: {
    config(newVal) {
      if (newVal) {
        this.localEventConfig = cloneDeep(this.config);
      }
    },
  },
  data() {
    return {
      localEventConfig: cloneDeep(this.config),
    };
  },
  methods: {
    onSave() {
      this.$emit('save', this.localEventConfig);
    },

    onCancel() {
      this.localEventConfig = cloneDeep(this.config);
    },
  },
};
</script>

<style lang="scss" scoped>
.question-mark {
    padding-left: 5px;
}
.execution-event {
  margin-bottom: 10px;
}

.workflow-container {
  width: 50%;
}

</style>
